import * as api from '../api/index'

import { ADD_NEW_INVENTORY, UPDATE_INVENTORY, DELETE_INVENTORY, GET_INVENTORY, FETCH_INVENTORY_BY_USER, START_LOADING, END_LOADING } from './constants'



export const getInventoriesByUser =(searchQuery) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING })
      dispatch({ type: FETCH_INVENTORY_BY_USER, payload: [] });
      const  { data }  = await api.fetchInventoriesByUser(searchQuery)
      dispatch({ type: FETCH_INVENTORY_BY_USER, payload: data.results });
      dispatch({ type: END_LOADING })
    } catch (error) {
      console.log(error.response)
      
    }
  }


export const getInventory = (id) => async (dispatch)=> {

    const user = JSON.parse(localStorage.getItem('profile'))

    try {
        const { data } = await api.fetchInventory(id)
        dispatch({ type: GET_INVENTORY, payload: data.results[0]  })
    } catch (error) {
        console.log(error.response)
    }
}

export const createInventory =(inventory, history,openSnackbar) => async (dispatch) => {
    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.addInventory(inventory)
        await dispatch({ type: ADD_NEW_INVENTORY, payload: data })
        openSnackbar("Inventory added successfully")
        dispatch({ type: END_LOADING })
        history.push(`/inventories`)

    } catch (error) {
        console.log(error)
    }
}

export const updateInventory =(id, inventory, history,openSnackbar) => async (dispatch) => {

    try {
        dispatch({ type: START_LOADING })
        const { data } = await api.updateInventory(id, inventory)
        await dispatch({ type: UPDATE_INVENTORY, payload: data })        
        openSnackbar("Inventory updated successfully")
        dispatch({ type: END_LOADING })
        history.push(`/inventories`)

    } catch (error) {
        console.log(error)
    }
}

export const deleteInventory =(id, openSnackbar) => async (dispatch) => {
    try {
        await api.deleteInventory(id)
        dispatch({type: DELETE_INVENTORY, payload: id})
        openSnackbar("Inventroy deleted successfully")
    } catch (error) {
        console.log(error.response)
    }
}